import React from "react";
import { Card, CardBody, TabContent, TabPane } from "reactstrap";
import CardHeaderTabs from "@dhn/components/molecules/card-header-tabs";
import NewQuote from "./subTabsQuotes/NewQuote";
import CurrentQuotes from "./subTabsQuotes/CurrentQuotes";
import useActions from "./useActions";

const QUOTE_TABS = [
  { id: 1, name: "Nueva Cotización" },
  { id: 2, name: "Cotizaciones Vigentes" },
];

export default function Quotes({
  activeTab,
  handleParentChange,
  tabQuotes,
  medicalStaffId,
  specialityId,
  branchOfficeId,
  appointmentArsId,
  onChangeTabQuotationQuantity,
  dataAddTabServices,
  appointmentId,
  activeTabFather,
  isPageModalHistory,
}) {
  const { quotations } = tabQuotes;
  const [
    { state, serviceOptions, loadingServiceOptions, loadinggetQuotationsByAppointment },
    actions,
  ] = useActions({
    medicalStaffId,
    specialityId,
    branchOfficeId,
    quotations,
    handleParentChange,
    appointmentArsId,
    activeTab,
    dataAddTabServices,
    appointmentId,
    activeTabFather,
    isPageModalHistory,
  });

  return (
    <TabPane tabId={6} className="p-0 m-0">
      <Card>
        <CardHeaderTabs
          onClick={(id) => handleParentChange("activeTabQuote", id)}
          active={activeTab}
          tabs={QUOTE_TABS}
        />
        <CardBody>
          <TabContent className="border-0" activeTab={activeTab}>
            <NewQuote
              quotationsDetails={quotations?.quotationsDetails || []}
              serviceOptions={serviceOptions}
              loadingServiceOptions={loadingServiceOptions}
              onAddService={actions.handleAddService}
              onRemoveService={actions.handleRemoveService}
              onChangeQuantity={onChangeTabQuotationQuantity}
              isPageModalHistory={isPageModalHistory}
            />
            <CurrentQuotes
              quotations={state.dataQuotationsByAppointment}
              loading={loadinggetQuotationsByAppointment}
              modalIsOpen={state.modalIsOpen}
              selectedQuotation={state.selectedQuotation}
              servicesSeleted={state.servicesSeleted}
              onSelectQuotation={actions.handleSelectedQuotation}
              onCloseQuotation={actions.handleCloseQuotation}
              onSelectService={actions.handleAddServices}
              onAddServices={actions.handleAddServicesFromQuotation}
              isPageModalHistory={isPageModalHistory}
            />
          </TabContent>
        </CardBody>
      </Card>
    </TabPane>
  );
}
